import React from 'react';

import _ from "lodash";
import styles from "./CreateUserServiceCall.module.scss";
import {$getLanguage, $t} from "../../helpers/translator";
import api from "../../helpers/api";
import Loader from "../miscellaneous/Loader/Loader";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";

import {connect} from "react-redux";
import {getUser, getUserClinic} from "../../store/auth-slice";
import {getApplicators, getPlatforms, getClinics} from "../../store/data-slice";
import {setAlert} from "../../store/alerts-slice";


class CreateUserServiceCall extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lang: $getLanguage(),

            successMessage: '', errorMessage: '', loading: false,

            values: {
                submitterName: {
                    value: '', validation: [{maxLength: 255}, {required: $t('validation.general.required')},], error: ''
                }, submitterEmail: {
                    value: '',
                    validation: [{
                        regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                        errorText: $t('validation.general.email')
                    }, {maxLength: 50}, {required: $t('validation.general.required')},], error: ''
                }, submitterPhoneNumber: {
                    value: '',
                    validation: [
                        {maxLength: 20},
                        {required: $t('validation.general.required')}, {
                        regex: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                        errorText: $t('validation.general.phoneNumber')
                    },], error: ''
                },

                text: {
                    value: '', validation: [{maxLength: 255}, {required: $t('validation.general.required')}], error: ''
                }, machineId: {
                    value: '', validation: [], error: ''
                }, applicatorId: {
                    value: '', validation: [], error: ''
                },
            },

            selectedSystemDownOption: {
                label: $t('global.general.no'), value: 0
            }, systemDownOptions: [{
                label: $t('global.general.yes'), value: 1
            }, {
                label: $t('global.general.no'), value: 0
            },],

            platformOptions: [], selectedPlatformOption: [],

            applicatorOptions: [], selectedApplicatorOption: [],

            clinicOptions: [], selectedClinicOption: [],
        };
    }

    async componentDidMount() {
        // let accountData = await this.props.dispatch(getAccountData());
        let user = await this.props.dispatch(getUser());
        let clinic = await this.props.dispatch(getUserClinic());
        let values = {...this.state.values}

        values['submitterName'].value = user.name ? user.name : '';
        values['submitterEmail'].value = user.email ? user.email : '';
        values['submitterPhoneNumber'].value = clinic && clinic.phone ? clinic.phone : '';

        this.setState({
            values: values,
        }, async () => {
            await this.getPlatformsOptions();
            await this.getApplicatorsOptions();
            await this.getClinics();
        })
    }

    async getPlatformsOptions() {
        let res = await this.props.dispatch(getPlatforms());
        let platforms = [...res];
        platforms.unshift({
            label: $t('global.service.notPlatformRelated'), value: ''
        })

        this.setState({
            platformOptions: platforms, selectedPlatformOption: [platforms[0]]
        })
    }

    async getApplicatorsOptions() {
        let res = await this.props.dispatch(getApplicators());
        let applicators = [...res];
        applicators.unshift({
            label: $t('global.service.notApplicatorRelated'), value: ''
        })

        this.setState({
            applicatorOptions: applicators, selectedApplicatorOption: [applicators[0]]
        })
    }

    async getClinics() {
        let res = await this.props.dispatch(getClinics());
        let clinics = [...res];
        clinics.unshift({
            label: $t('global.service.notClinicRelated'), value: ''
        })

        this.setState({
            clinicOptions: clinics, selectedClinicOption: [clinics[0]]
        })
    }

    async formSentClickHandler() {
        this.setState({
            successMessage: '', errorMessage: ''
        });

        let validated = this.validateForm();
        // console.log('val result: ', validated);

        if (validated) {
            let payload = {
                sender_name: this.state.values.submitterName.value,
                sender_email: this.state.values.submitterEmail.value,
                sender_phone: this.state.values.submitterPhoneNumber.value,
                system_down: this.state.selectedSystemDownOption.value,
                platform_id: this.state.selectedPlatformOption.value,
                applicator_id: this.state.selectedApplicatorOption.value,
                clinic_id: this.state.selectedClinicOption.value,
                text: this.state.values.text.value.replace(/(?:\r\n|\r|\n)/g, '<br>'),
            };

            try {
                this.setState({loading: true}, async () => {
                    let res = await api.post('service/user/create', payload);

                    if (!res || !res.data || !res.data.success) {
                        let error = res.data && res.data.error && res.data.error.errorText ? res.data.error.errorText : 'Error submitting form';
                        this.setState({
                            errorMessage: error, loading: false
                        });
                        return;
                    }

                    this.setState({loading: false}, () => {
                        this.props.dispatch(setAlert({type: 'success'}))
                        this.props.onClose();
                        this.setState({loading: false})
                    })

                });
            } catch (e) {
                console.error('err sending contact us', e);
            } finally {
                // this.setState({loading: false})
            }
        }
    }

    validateForm() {
        let validated = true;
        let values = {...this.state.values};
        // console.log('valvalues', values)

        _.forEach(values, (v, k) => {
            v.error = '';
            _.forEach(v.validation, (valObj, valKey) => {

                if (valObj.regex) {
                    // console.log(k, v.value, valObj, (valObj.regex).test(v.value));
                    if (!(valObj.regex).test(v.value)) {
                        v.error = valObj.errorText;
                        validated = false;
                    }
                }
                if (valObj.required && (!v.value.length && !v.value)) {
                    // console.log(k, v, v.value, 'Required', v.value.length);
                    v.error = valObj.required;
                    validated = false;
                }
                if (valObj.maxLength && v.value.length > valObj.maxLength) {
                    // console.log(k, v.value, 'maxLength', v.value.length);
                    // v.error = 'Length should not exceed ' + valObj.maxLength + 'characters';
                    v.error = $t('validation.general.maxLength').replace('{0}', valObj.maxLength);
                    validated = false;
                }
            });
        });

        let errorMessage = validated ? '' : $t('global.service.serviceCall.someFieldsContainErrors');

        this.setState({
            values: values, errorMessage: errorMessage
        });

        return validated;
    }

    valueChangeHandler(e) {
        // console.log('valueChangeHandler-valueChangeHandler', e.target.name, e.target.value);
        let values = {...this.state.values};
        values[e.target.name].value = e.target.value;
        values[e.target.name].error = '';

        this.setState({values: values});
    }

    selectChangeHandler(name, data) {
        let state = {...this.state};

        state['selected' + name.charAt(0).toUpperCase() + name.slice(1) + 'Option'] = data;
        this.setState(state)
    }


    render() {
        return (<div className={styles['container']}>
            {this.state.successMessage ? <div className={styles['success']}>
                <div>
                    <div className={styles['bold']}>{$t('global.service.serviceCall.serviceCallReceived')}</div>
                    <div>{$t('global.service.serviceCall.emailSent')}</div>
                </div>
            </div> : null}
            {this.state.loading ? <div className={styles['overlay']}>
                <Loader/>
            </div> : null}
            {!this.state.successMessage ? <>
                <div className={`${styles.row} ${styles['cu-header']}`}>
                    <div>{$t('global.service.serviceCall.openServiceCall')}</div>
                </div>
                <div className={'alma-fields-section'}>
                    <div className={'alma-fields-row'}>
                        <div className={'alma-field-container'}>
                            <div
                                className={'alma-field-header'}>{$t('global.service.serviceCall.name')}</div>
                            <input name="submitterName"
                                   className={'alma-input'}
                                   type="text"
                                   value={this.state.values.submitterName.value}
                                   placeholder={$t('global.service.serviceCall.enterYourName')}
                                   onChange={(e) => this.valueChangeHandler(e)}
                            />
                            <div className={'alma-field-error'}>{this.state.values.submitterName.error}</div>
                        </div>
                    </div>
                    <div className={'alma-fields-row'}>
                        <div className={'alma-field-container'}>
                            <div
                                className={'alma-field-header'}>{$t('global.service.serviceCall.phoneNumber')}</div>
                            <input name="submitterPhoneNumber"
                                   className={'alma-input'}
                                   type="tel"
                                   value={this.state.values.submitterPhoneNumber.value}
                                   placeholder={$t('global.service.serviceCall.enterPhoneNumber')}
                                   onChange={(e) => this.valueChangeHandler(e)}
                            />
                            <div
                                className={styles['error-text']}>{this.state.values.submitterPhoneNumber.error}</div>
                        </div>

                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.service.serviceCall.email')}</div>
                            <input name="submitterEmail"
                                   className={'alma-input'}
                                   type="text"
                                   value={this.state.values.submitterEmail.value}
                                   placeholder={$t('global.service.serviceCall.enterEmail')}
                                   onChange={(e) => this.valueChangeHandler(e)}
                            />
                            <div className={styles['error-text']}>{this.state.values.submitterEmail.error}</div>
                        </div>
                    </div>
                </div>

                <div className={'alma-fields-section'}>
                    <div className={'alma-fields-row'}>
                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.service.systemDown')}</div>
                            <MultiSelect
                                options={this.state.systemDownOptions}
                                selected={this.state.selectedSystemDownOption}
                                onValueChange={(data) => this.selectChangeHandler('systemDown', data)}
                            />
                            {/*<div className={styles['error-text']}>{this.state.values.systemDown.error}</div>*/}
                        </div>
                        {this.props.userType === 3 ?

                            <div className={'alma-field-container'}>
                                <div
                                    className={'alma-field-header'}>{$t('global.service.clinic')}</div>
                                <div className={styles['select']}>
                                    <MultiSelect
                                        options={this.state.clinicOptions}
                                        selected={this.state.selectedClinicOption}
                                        onValueChange={(data) => this.selectChangeHandler('clinic', data)}
                                    />
                                </div>
                            </div>
                            : null
                        }
                    </div>
                </div>

                <div className={'alma-fields-section'}>
                    <div className={'alma-fields-row'}>
                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.service.platform')}</div>
                            <MultiSelect
                                searchable={true}
                                options={this.state.platformOptions}
                                selected={this.state.selectedPlatformOption}
                                onValueChange={(data) => this.selectChangeHandler('platform', data)}
                            />
                            {/*<div className={styles['error-text']}>{this.state.values.machineId.error}</div>*/}
                        </div>


                        <div className={'alma-field-container'}>
                            <div className={'alma-field-header'}>{$t('global.service.applicator')}</div>
                            <MultiSelect
                                searchable={true}
                                options={this.state.applicatorOptions}
                                selected={this.state.selectedApplicatorOption}
                                onValueChange={(data) => this.selectChangeHandler('applicator', data)}
                            />
                        </div>
                    </div>
                </div>

                <div className={'alma-fields-row'}>
                    <div className={'alma-field-container'}>
                        <div className={'alma-field-header'}>{$t('global.service.serviceCall.content')}</div>
                        <textarea name="text"
                                  className={'alma-input-textarea'}
                                  style={{height: '150px'}}
                                  rows={5}
                                  value={this.state.values.text.value}
                                  placeholder={$t('global.service.serviceCall.explainProblem')}
                                  onChange={(e) => this.valueChangeHandler(e)}
                        />
                        <div className={styles['error-text']}>{this.state.values.text.error}</div>
                    </div>
                </div>

                <div className={`${styles.row} ${styles['bottom-row']}`}>
                    <div className={`${styles.row} ${styles['bottom-row']} ${styles['error']}`}>
                        <div>{this.state.errorMessage}</div>
                    </div>
                    <div className={'alma-button'}
                         onClick={() => this.formSentClickHandler()}>{$t('global.service.serviceCall.submit')}</div>
                </div>
            </> : null}
        </div>);
    }
}

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(CreateUserServiceCall);

// export default CreateUserServiceCall;
